import { FETCH_ATTRIBUTES_FAILURE } from './attributes.action';

// GTM-UPDATE
const addToDataLayer = data => window.dataLayer.push(data);

export const AttributesAnalytics = {
	// [FETCH_ATTRIBUTES_FAILURE]: attributesFetchFailed,
	[FETCH_ATTRIBUTES_FAILURE]: action => addToDataLayer({
		event: 'failure',
		data: action.payload
	})
};
